/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
//window.VueSignaturePad = require('vue-signature-pad');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('shipping-license-component', require('./components/ShippingLicenseComponent.vue').default);
Vue.component('charter-license-component', require('./components/CharterLicenseComponent.vue').default);
Vue.component('check-component', require('./components/CheckComponent.vue').default);
Vue.component('checkerror-component', require('./components/CheckerrorComponent.vue').default);
Vue.component('checkout-component', require('./components/CheckOutComponent.vue').default);
Vue.component('precheck-component', require('./components/PreCheckComponent.vue').default);
Vue.component('sign-pad', require('./components/SignPad.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

(function () {
    // Get all images with the `detail-view` class
    var zoomBoxes = document.querySelectorAll('.detail-view');

    // Extract the URL
    zoomBoxes.forEach(function (image) {
        var imageCss = window.getComputedStyle(image, false),
            imageUrl = imageCss.backgroundImage
                .slice(4, -1).replace(/['"]/g, '');

        // Get the original source image
        var imageSrc = new Image();
        imageSrc.onload = function () {
            var imageWidth = imageSrc.naturalWidth,
                imageHeight = imageSrc.naturalHeight,
                ratio = imageHeight / imageWidth;

            // Adjust the box to fit the image and to adapt responsively
            var percentage = ratio * 100 + '%';
            image.style.paddingBottom = percentage;

            // Zoom and scan on mousemove
            image.onmousemove = function (e) {
                // Get the width of the thumbnail
                var boxWidth = image.clientWidth,
                    // Get the cursor position, minus element offset
                    x = e.pageX - this.offsetLeft,
                    y = e.pageY - this.offsetTop,
                    // Convert coordinates to % of elem. width & height
                    xPercent = x / (boxWidth / 100) + '%',
                    yPercent = y / (boxWidth * ratio / 100) + '%';

                // Update styles w/actual size
                Object.assign(image.style, {
                    backgroundPosition: xPercent + ' ' + yPercent,
                    backgroundSize: imageWidth + 'px'
                });
            };

            // Reset when mouse leaves
            image.onmouseleave = function (e) {
                Object.assign(image.style, {
                    backgroundPosition: 'center',
                    backgroundSize: 'cover'
                });
            };
        }
        imageSrc.src = imageUrl;
    });
})();
